import React from 'react';
import Box from '@mui/material/Box';
import LaboxInventory from 'icons/LaboxInventory';
import { CircularProgress } from '@mui/material';
import Footer from './Footer';

export default function LoadingPage() {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LaboxInventory width="180" />
      <CircularProgress />
      <Footer minimal />
    </Box>
  );
}
